const alertBellSubtle = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M10.29 13.71a2.29 2.29 0 1 1-4.58 0ZM8 1.5A3.47 3.47 0 0 1 11.5 5v3a5.48 5.48 0 0 0 1.41 3.5H3.09A5.48 5.48 0 0 0 4.5 8V5A3.47 3.47 0 0 1 8 1.5M8 0a5 5 0 0 0-5 5v3a4.35 4.35 0 0 1-1.5 3H1a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2h-.5A4.35 4.35 0 0 1 13 8V5a5 5 0 0 0-5-5"/></svg>',
};

export { alertBellSubtle as default };
